/**
 * Post-login destination — admins never land in the student portal.
 * Students always open the dashboard (billing/plan CTAs live there when unpaid).
 */
export function getPortalHomePath({ isAdmin }) {
  if (isAdmin) return '/admin';
  return '/dashboard';
}
